'use strict';

$('body').on('click', '.togglePassword', function () {
    $(this).toggleClass('icon-eye-hide-show-password icon-eye-slash');
    var password = $(this).closest('.password-form').find('.password');
    var type = password.attr('type') === 'password' ? 'text' : 'password';
    password.attr('type', type);
});
